import React from 'react';
import { Box, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { btnType, Button } from '../../atoms/button';
import { Icons } from '../../../icons';
import { MEMBER_ACTIONS } from '../../templates/sessions/sessions.constants';
import { useStyles } from './MemberActions.styles';

/**
 * MemberActions component for member profiles, AMA, scheduling, and chat.
 */
const MemberActions = ({
  onMemberActionClick,
  chatIconGlyph = 'message',
  className,
  expanded = true,
  showText = false,
}) => {
  const classes = useStyles({ expanded, showText });

  const actionButtons = [
    {
      id: MEMBER_ACTIONS.PROFILE,
      title: 'Member profile',
      icon: 'member',
      label: 'View member profile',
    },
    {
      id: MEMBER_ACTIONS.AMA,
      title: 'Ask me anything',
      icon: 'question-outlined',
      label: 'Ask us anything',
    },
    {
      id: MEMBER_ACTIONS.SCHEDULE,
      title: 'Schedule new appointment',
      icon: 'calendar-checked-outlined',
      label: 'Schedule appointment',
    },
    {
      id: MEMBER_ACTIONS.CHAT,
      title: 'Care team chat',
      icon: chatIconGlyph,
      label: 'Chat with care team',
    },
  ];

  const renderButton = button => (
    <Button
      key={button.id}
      variant={btnType.OUTLINE}
      className={clsx([classes.actionBtn, {
        [classes.actionBtnLabel]: showText,
      }])}
      onClick={() => onMemberActionClick(button.id)}
    >
      {showText && <span className={classes.buttonLabel}>{button.label}</span>}
      <Icons glyph={button.icon} />
    </Button>
  );

  return (
    <Box className={clsx(classes.memberActionsWrapper, className)}>
      {actionButtons.map(button => {
        return (
          <Tooltip key={button.id} title={button.title}>
            <span>{renderButton(button)}</span>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export { MemberActions };
